import { FooterDisclaimerItemFragment, ImageFragment, KeyValueDataFragment } from './fragments';
import gql from 'graphql-tag';

export const VcxLandingPageQuery = gql`
	query VcxLandingPage {
		allVcxLandingPage {
			_id
			vcxFundDetailsUpdateAsOfDate
			vcxPortfolioDescription: vcxPortfolioDescriptionRaw
			vcxPortfolioHoldings {
				...KeyValueDataFragment
			}
			vcxSectorBreakdown {
				...KeyValueDataFragment
			}
			vcxPrivatePublicBreakdown {
				...KeyValueDataFragment
			}
			vcxPortfolioSectionDisclaimer
			vcxPerformanceData {
				...KeyValueDataFragment
			}
			vcxPerformanceDisclaimer
			vcxFeaturedPodcasts {
				title
				description
				applePodcastLink
				spotifyPodcastLink
				podcastImage {
					...ImageFragment
				}
			}
			vcxFooterDisclaimers {
				...FooterDisclaimerItemFragment
			}
		}
	}
	${KeyValueDataFragment}
	${ImageFragment}
	${FooterDisclaimerItemFragment}
`;
